import axios from 'axios';
import stgConfig from "../../../config";
import Environment from '../buyer-experience/common/environment';

const STAGING_ENDPOINT = `${window.location.hostname.indexOf('qa-wac') > -1 ? 'https://qa-wac.internal.atlassian.com' : stgConfig.stgWacInternalUrl}/endpoint`;

const BXP_EXPRESS_ENDPOINT = {
  [Environment.production()]: 'https://www.atlassian.com/endpoint',
  [Environment.staging()]: STAGING_ENDPOINT,
  [Environment.dev()]: STAGING_ENDPOINT,
};

/**
 * Submit a post request to bxp express /webinarsignup/updatestreamhub endpoint
 * this endpoint should take the email address and emit an event to streamhub
 * @param {*} userEmail
 */

export const postEmailToStreamHub = (userEmail: string) => {
  const environment = Environment.getEnvironment();
  return axios.post(`${BXP_EXPRESS_ENDPOINT[environment]}/webinarsignup/updatestreamhub`, {
    user_email: userEmail
  });
};

export const postObjectToStreamhubContact = (obj, endpoint, responseHandler, errorHandler, state) => {
  console.log('endpoint', endpoint)
  const environment = Environment.getEnvironment();
  return axios.post(`${BXP_EXPRESS_ENDPOINT[environment]}/streamhub/${endpoint}`, obj)
    .then(
      (response) => {
        if (responseHandler) {
          new responseHandler(response, state);
        }
      },
      (error) => {
        if (errorHandler) {
          new errorHandler(error, state);
        }
      }
    );
}